import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function ChannelsIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path
        d="M114 66q8 14 0 28M122 56q14 24 0 48M46 66q-8 14 0 28M38 56q-14 24 0 48"
        stroke={c.a400}
        strokeWidth="4"
      />
      <rect x="56" y="38" width="48" height="86" rx="10" fill={c.p600} />
      <rect x="62" y="48" width="36" height="62" rx="4" fill={c.n0} />
      <rect x="72" y="42" width="16" height="3" rx="1.5" fill={c.p300} />
      <rect x="68" y="60" width="24" height="16" rx="6" fill={c.p500} />
      <rect x="70" y="84" width="20" height="12" rx="5" fill={c.p200} />
    </Frame>
  );
}
